export const SCALE = 2
export const FPS_COUNT = 60
export const OVERFLOW = 200
